
import { Routes, Route, Link } from "react-router-dom";
import React, { useState, useEffect,useRef } from "react";
import ImageUploading from 'react-images-uploading';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { Atom,Mosaic } from "react-loading-indicators";
import { auth } from "../firebase/firebaseDb.js";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

import { 
FacebookAuthProvider,
 GoogleAuthProvider,
 signInWithPopup ,
 signInWithRedirect,
 OAuthProvider,
 sendSignInLinkToEmail,
 createUserWithEmailAndPassword,
 signInWithEmailAndPassword,
 updateProfile,
 sendEmailVerification
 } from "firebase/auth";










export default function Registration() {
	
	 const modalRef = useRef();
	 const { t } = useTranslation();
	// const [progress, setProgress] = useState(10); // initial 10%
	  
	   const [email, setEmail] = useState('');
	    const [fullName, setFullName] = useState('');
       const [password, setPassword] = useState('');
	  
  
  
     const [selectedServiceName, setSelectedServiceName] = useState('');
       const [selectedServiceDescription, setSelectedServiceDescription] = useState('');
	   const [serviceMode, setServiceMode] = useState('save');
	   const [oldServiceName, setOldServiceName] = useState('');
	   
	   const [businessName, setBusinessName] = useState('');
	   const [businessType, setBusinessType] = useState('');
	   const [businessAddress, setBusinessAddress] = useState('');
	   const [businessEmail, setBusinessEmail] = useState('');
	   const [businessPhone, setBusinessPhone] = useState('');
	    const [services, setServices] = useState([]);
	   const [images, setImages] = React.useState([]);
  	   
		
	   const [step, setStep] = useState(0);
	   const [inputReply, setInputReply] = useState('');
	    const [showInputReply, setShowInputReply] = useState('flex');
	 const [showSpinner, setShowSpinner] = useState('none');	
	   const [stepInput,setStepInput]=useState('');
	   const maxNumber = 15;
	   const [websiteGeneratorStatus, setWebsiteGeneratorStatus] = useState('');
	  const [remoteImages, setRemoteImages] = useState([]); 
   const [createdWebsiteID, setCreatedWebsiteID] = useState('');	  
	   const [openAIResult, setOpenAIResult]=useState(null);
	   const [urlPath, setUrlPath]=useState('');
	    const [showModalLoader, setShowModalLoader]=useState('none'); 
	    const [pn, setPn] = useState() 
	  
	   
	 const questions = [
    "Let’s get started! What’s the name of your business?",
    "Which type of activity are your business serve?",
    "Where is your business located?",
	"What's your email",
	"What is your phone number",
    "What’s your business products or services?",
	"Choose few images in your library that will be use for your website"
  ];

  const placeholders = [
     "eg ZuriBuild Inc.",
	"eg barbershop",
    "eg Lagos, Nigeria",
    "eg example@email.com",
	"Your phone number",
	"Services / products",
	"Images gallery"
  ];
  
  
  
  
  
  const WP_API = "http://localhost/zuribuild/panecran/wp-json/wp/v2/pages";
const USERNAME = "root"; // your WP username
const APP_PASSWORD = "sKy6 q263 5Aq7 FVOv R44X P27G"; // your generated Application Password
const token = btoa(`${USERNAME}:${APP_PASSWORD}`);

const navigate = useNavigate();






 
	    useEffect(() => {
	//  i18n.changeLanguage("fr");
	//  console.log(i18n.languages[1])
  // alert(localStorage.getItem('i18nextLng'))

	/*try {
    const response = await axios.post(
      WP_API,
      {
        title: "My API Page (Axios)",
        content: "This page was created via Axios and WP REST API 🚀",
        status: "publish",
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
      }
    );

    console.log("✅ Page created:", response.data);
  } catch (error) {
    console.error("❌ Error creating page:", error.response?.data || error);
  } */
	  
	  
	  
	/*  
	  try {
    // Format the path from business name
    const path = businessName.toLowerCase().replace(/\s+/g, '-');

    // Send POST request to your WordPress REST API
    const response = await axios.post('http://localhost/zuribuild/wp-json/custom/v1/create-site/', {
      path: 'zuribuild/panecran',
      title: 'panecran',
	  domain: 'localhost/'
    },
	{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
      }
	  );

    // Log the new site data
    console.log('New site created:', response.data);
    // Example: access the new site
    console.log('Visit the site at:', response.data.url);

    return response.data.url;
  } catch (error) {
    console.error('Error creating website:', error.response?.data || error.message);
  }
  */
   },[]);
  















  




const  register2 = async () => {
	const actionCodeSettings = {
  // The URL to redirect to for password resets, email verification, etc.
  url: process.env.REACT_APP_FIREBASE_EMAIL_REGISTRATION_LOGIN_LINK, // Change this to your production URL later
  handleCodeInApp: true,
};

	
  setShowSpinner("inline-block")
		
	if(fullName=='' || email=='' || password==''){
		
		setShowInputReply('flex');
		setInputReply(t("registration.you_have_to_fill"));
		setShowSpinner("none")
	}
		
		
	else{	
   setShowSpinner("inline-block")
    setShowModalLoader('flex')
      const userCredential = await createUserWithEmailAndPassword(auth, email, password)
     
	   .then((userCredential) => {
     	  	const payload={
		user_id: userCredential.user.uid,
          full_name: fullName,
          email: email,
		  is_verified: 0
		
	  }
	  
	   updateProfile(userCredential.user, { displayName: fullName });
	  
	  const user = userCredential.user;
	  //  sendEmailVerification(user);
		sendEmailVerification(user, actionCodeSettings);
		 addUser(payload,"no")
    })
	  
	  .catch((error) => {
    //  console.error("❌ Firebase Error:", error.code);
	 setShowModalLoader('none')
      setShowSpinner("none")
	  
      if (error.code === "auth/email-already-in-use") {
        // show message in your UI instead of a modal
   
      console.error(error.message);
	  
	   toast.error("This email is already registered. Please login instead.", {
      position: 'top-right',
	  autoClose:true
    });
	
        
      } else if (error.code === "auth/invalid-email") {
          toast.error("Invalid email address", {
      position: 'top-right',
    });
      }
	  else if (error.code === "auth/weak-password") {
         toast.error("Password is too weak", {
      position: 'top-right',
    });
      } 
	  else {
       
		   toast.error( error.message, {
      position: 'top-right',
    });
      }
    });
	  
	  

   // addUser(payload)
    //  alert("Verification email sent. Please check your inbox before logging in.");
	
	
	  
	

    }

};






const addUser=async(payload,provider,firebaseUser)=>{
	//alert(firebaseUser)
	
	//	await axios.post("http://10.0.0.73/zuribuildAPI/add-user.php", payload, {
	//  await	  axios.post("http://localhost/zuribuildAPI/add-user.php", payload, {
		await axios.post(process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/add-user.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		// setShowModalLoader('none')
		 setShowSpinner('none');
      console.log("Response:", res.data);
	
  alert("Congratulation !!! Your registration was successful");
    
	if(provider=="no"){
	loginUserWithEmail(email,password)
	}
	
	else if(provider=="gmail"){
	loginUserWithEmail2(email,password,firebaseUser)	
	}
	
	else if(provider=="facebook"){
	loginUserWithEmail3(email,password,firebaseUser);	
	}
 // navigate('/dashboard');
  
	
	 
    })
     
     .catch ((err)=> {
		  setShowModalLoader('none')
		 setShowSpinner("none")
		console.log(err)
      console.error(err.message);
	  
	   toast.error(err.message, {
      position: 'top-right',
    });
	
		
	
    })
	
	
	
	
}













const  register = async () => {
	//alert(fullName)

	
  setShowSpinner("inline-block")
		
	if(fullName=='' || email=='' || password==''){
		
		setShowInputReply('flex');
		setInputReply(t("registration.you_have_to_fill"));
		setShowSpinner("none")
	}
		
		
	else{	
   setShowSpinner("inline-block")
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      await updateProfile(userCredential.user, { displayName: fullName });
	  
	  
	  	const payload={
		user_id: userCredential.user.uid,
          full_name: fullName,
          email: email,
		  is_verified: 0
		
	  }
	  
	  
	  
	  const user = userCredential.user;
	  
	  
	    await sendEmailVerification(user);
  
    //  alert("Verification email sent. Please check your inbox before logging in.");
	
	 // await	  axios.post("http://localhost/zuribuildAPI/add-user.php", payload, {
		  await	  axios.post(process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/add-user.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	
  alert("Congratulation !!! Your registration was successful");
    
	
	loginUserWithEmail(email,password)
 // navigate('/dashboard');
  
	
	 
    })
     
     .catch ((err)=> {
		 setShowSpinner("none")
		console.log(err);
      console.error(err.message);
	 // alert(err)
	   toast.error(err.message, {
      position: 'top-right',
    });
	
		
	
    })
	  
	

    }
};



//function to login via firebase auth

const  loginUserWithEmail= async (email,password) => {
	
	
	
try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    if (user) {
      console.log("Login successful!", user);
	  localStorage.setItem("firebase_user", JSON.stringify(user))
      // Proceed with backend API call or redirect
	//  navigate('/dashboard');
	  finalizeLogin(userCredential.user.uid)
    } else {
      alert("Please verify your email before logging in.");
    }
  } catch (error) {
	   setShowModalLoader('none')
	  setShowSpinner("none")
    console.error("Login failed:", error.message);
	   toast.error(error.message, {
      position: 'top-right',
    });
  }
  
};




//login user with email from a gmail or facebook oauth provider



const  loginUserWithEmail2= async (email,password,firebaseUser) => {
	
	
	  localStorage.setItem("firebase_user", JSON.stringify(firebaseUser))
      // Proceed with backend API call or redirect
	//  navigate('/dashboard');
	 
    window.location.href="/dashboard";

	

  
};













//function to login with faceboki oauth

const  loginUserWithEmail3= async (email,password,firebaseUser) => {
//alert(firebaseUser)
  localStorage.setItem("firebase_user", JSON.stringify(firebaseUser))
      // Proceed with backend API call or redirect
	 
	  
	  setTimeout(function() {
 navigate('/dashboard');
}, 5000);

}



//  function to login via our own dedicted php myql server to get the user profile completentary information


const finalizeLogin=async(user_id)=>{
	
	const payload={
		user_id: user_id,

	  }
	
	  await	  axios.post(process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/login-user.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowModalLoader('none')
		 setShowSpinner('none');
      console.log("Response:", res.data);
	
 // alert("Congratulation !!! Your registration was successful");
    setShowSpinner("none")
	
	localStorage.setItem('user_info',JSON.stringify(res.data))
    navigate('/dashboard');
  
	
	 
    })
     
     .catch ((err)=> {
		  setShowModalLoader('none')
		 setShowSpinner("none")
		
      console.error(err.message);
	     toast.error(err.message, {
      position: 'top-right',
    });
    })
}























//function to save user email

const  loginUser= async (email) => {
	
//setShowSpinner('inline-block')
	  const payload={
		
		 email: email,
		 
		
	  }
	  axios.post(process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/login-user.php", payload, {
	 // axios.post("http://localhost/zuribuildAPI/login-user.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	
  alert(res.data);
  
 navigate("/dashboard");
  
	
	 
    })
    .catch((err) => {
		 setShowSpinner('none')
      console.error("Error:", err.message);
	   toast.error(err.message, {
      position: 'bottom-right',
    });
    });
};















const loginWithFacebook = async () => {
	 setShowModalLoader('flex')
  const provider = new FacebookAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider); 
    console.log("Facebook user:", result.user);
	
	 // console.log("Google user:", result.user);
	
	const payload={
		user_id: result.user.uid,
          full_name: result.user.displayName,
          email: result.user.email,
		  is_verified: 0
		
	  }
	  
	
	  
	  const user = result.user;
	  
		 addUser(payload, "facebook",user)
  } catch (error) {
	   setShowModalLoader('none')
    console.error(error.message);
  }
};




const loginWithGmail = async () => {
	 setShowModalLoader('flex')
  const provider = new GoogleAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    console.log("Google user:", result.user);
	
	const payload={
		user_id: result.user.uid,
          full_name: result.user.displayName,
          email: result.user.email,
		  is_verified: 0
		
	  }
	  
	
	  
	  const user = result.user;
	  
		 addUser(payload, "gmail",user)
	
	
  } catch (error) {
	   setShowModalLoader('none')
    console.error(error);
  }
};








const loginWithMicrosoft = async () => {
  const provider = new OAuthProvider("microsoft.com");
  try {
    const result = await signInWithPopup(auth, provider);
    console.log("Microsoft user:", result.user);
  } catch (error) {
    console.error(error);
  }
};




const loginWithYahoo = async () => {
  const provider = new OAuthProvider("yahoo.com");
  try {
    const result = await signInWithPopup(auth, provider);
    console.log("Yahoo user:", result.user);
  } catch (error) {
    console.error(error);
  }
};









  
  
   const handleNext = () => {
	   //alert(step)
  /*  if (step < questions.length - 1) {
      setStep(step + 1);
    } */
	
	   if (step < questions.length - 1) {
	if(step==0){
		if(businessName==''){
		alert("this have to be filled")	
		}
		
		else{
		checkBusinessName(businessName)	
		}
	}
	
	
 if(step==1){
	 if(businessType==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 }	


 if(step==2){
	 if(businessAddress==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 }


 if(step==3){
	 if(businessEmail==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 } 
 
 
 
  if(step==4){
	 if(businessPhone==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 }
 
 
   if(step==5){
	
  setStep(step + 1);
		
 }
	   }
	

  };
  
  
  
  
  
  
  //function to check the business name in my database
  const checkBusinessName=async()=>{
	  setShowSpinner('inline-block')
	  const payload={
		 website_name:businessName, 
	  }
	  axios.post("http://10.0.0.12:80/zuribuildAPI/search-website.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	  if(res.data=='Business no found'){
		  setStep(step + 1);  
 setShowInputReply('none')
	setInputReply('')
	  }
	  
	  else{
		//alert("This business  already taken. You have to choose another business name") 
setShowInputReply('flex')
	setInputReply('This business name already taken. You have to choose another name')		
	  }
	//  alert(res) 
	
	 
    })
    .catch((err) => {
		 setShowSpinner('none')
      console.error("Error:", err);
	alert(err)
    });
	  
  }
  
  
  
  
  
  
   const onChangeImage = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  
  
  
  
  
  
  //function to check if the business name already exist in the database
  const checkBusinessNameAvailability=()=>{
	 // alert("we wil check if this business name already exist")
	  
  }
  
  
  
    const handleBack = () => {
		setShowInputReply('none ')		
		setInputReply('')
    if (step > 0) {
      setStep(step - 1);
    }
  };
  
  
  
    const addNewService = () => {

//  var newService=[{name:selectedServiceName, description:selectedServiceDescription}]
//  setServices([...services,{name:selectedServiceName, description:selectedServiceDescription}])
  
//  setSelectedServiceName('');
//  setSelectedServiceDescription('');
  
 /*if(services.lenght>0){
  console.log(services[0].name);
 } */
 const modal = window.bootstrap.Modal.getInstance(modalRef.current);

  if(serviceMode=='save'){
	  var newService=[{name:selectedServiceName, description:selectedServiceDescription}]
  setServices([...services,{name:selectedServiceName, description:selectedServiceDescription}])
	   modal.hide();
	   setSelectedServiceName('');
       setSelectedServiceDescription('');
	   setServiceMode('save');
  }
  
  else if(serviceMode=='edit'){
	//  alert(selectedServiceName)
 setServices((prevServices) =>
      prevServices.map((service) =>
        service.name === oldServiceName
          ? { name: selectedServiceName, description: selectedServiceDescription }
          : service
      )
    );
	  setServiceMode('save');
	   modal.hide();
	   setSelectedServiceName('');
       setSelectedServiceDescription('');
  }
   
   
  };
  
  
  
  
  
  
  
  

  // progress = (currentStep + 1) / totalSteps * 100
  const progress = ((step + 1) / questions.length) * 100;



 // Service functions
  const handleServiceChange = (index, field, value) => {
    const newServices = [...services];
    newServices[index][field] = value;
    setServices(newServices);
  };

  const addService = () => {
    setServices([...services, { name: "", description: "" }]);
  };
	
	
	
	 useEffect(() => {
  

  
  }, []);
	
	
	
	
	
	// Function to remove an item by id
  const removeService = (name) => {
	  
	//  alert(id)
    setServices((prevServices) =>
      prevServices.filter((service) => service.name !== name)
    );
  };
	
	
	//function to view the service detail
	const viewService = (name,description) => {

 
  setServiceMode('edit');
  setOldServiceName(name);
  setSelectedServiceName(name);
  setSelectedServiceDescription(description);
  
 /*if(services.lenght>0){
  console.log(services[0].name);
 } */

  
   const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    modal.show();
  };
	
	
	
	
	
	//function to close the service modal
	const closeModal = () => {

 
  
  setSelectedServiceName('');
  setSelectedServiceDescription('');
  

  
   const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    modal.hide();
  };
	
	
	
//function to replace a service 

const replaceService = (oldName, newService) => {
  setServices((prevServices) =>
    prevServices.map((service) =>
      service.name === oldName ? newService : service
    )
  );
};	
	
	
	
	
	
	
	
//function to normalize busines name with hyphen	
	
function normalizeBusinessName(name) {
  // Split into words, trim spaces, filter out empties
  const words = name.trim().split(/\s+/).filter(Boolean);
  
  // If only one word, return as is, else join with '-'
  return words.length > 1 ? words.join("-") : words[0];
}	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
//function to convert the json generate by openAI to wordpress Gutenbeerg syntax

// Utility: Convert AI JSON → WP Gutenberg blocks
function convertJsonToWpBlocks(pageJson) {
  let content = "";

  pageJson.sections.forEach((section) => {
	 // alert(section.images[0].url)
    content += `<!-- wp:group {"className":"custom-section"} -->
      <div class="wp-block-group custom-section">
        <h2>${section.title}</h2>
        <p>${section.paragraph}</p>
			
        
      </div>
    <!-- /wp:group -->`;
	
	if(section.images && section.images.length > 0){
		section.images.forEach((img) =>{
		content +=` <!-- wp:image {"url":"${img.url}","alt":"${img.alt || section.title}"} -->
		<div class="wp-block-image">
		 <img src="${img.url}"  class="section-image"/>
		 </div>
		 <!-- /wp:image -->
		 `;
		});
	}
	
	
	  
	
	
	
  }); 

  return content;
}
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
// rest API to create a new website subdomain on the server hosting


const createNewWebsite=async()=>{
	var formattedBusinessName=normalizeBusinessName(businessName)
	
	 try {
    // Format the path from business name
    const path = businessName.toLowerCase().replace(/\s+/g, '-');

    // Send POST request to your WordPress REST API
  //  const response = await axios.post('http://10.0.0.12:80/zuribuild/wp-json/custom/v1/create-site/', {
	 const response = await axios.post('http://localhost/zuribuild/wp-json/custom/v1/create-site/', {
      path: 'zuribuild/'+formattedBusinessName,
      title: businessName,
	  domain: 'localhost/'
    },
	{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
      }
	  );

    // Log the new site data
    console.log('New site created:', response.data);
	setUrlPath('zuribuild/'+formattedBusinessName);
	//alert(response.data.site_id);
	saveWebsiteClientInformationToDatabase(businessName,'zuribuild/'+formattedBusinessName)
 //  saveWebsiteClientInformationToDatabase(businessName,urlPath)
    // Example: access the new site
    console.log('Visit the site at:', response.data.url);
	//alert(response.data.url);
   
    return response.data.url;
  } catch (error) {
	  alert(error.message)
    console.error('Error creating website:', error.response?.data || error.message);
  }
}




const saveWebsiteClientInformationToDatabase=async(website_name,wp_url)=>{
	 setShowSpinner('inline-block')
	  const payload={
		 website_name:website_name, 
		 wp_url: wp_url,
		 id:1,
		 created_at: new Date(),
		 expiry_date: new Date(),
	  }
	  axios.post("http://localhost/zuribuildAPI/add-website.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	
  alert("Websites added successfully");
  
 // getNewImagesForWebsite();
 createWebsiteStructureViaAI(wp_url);
 deleteSamplePage(wp_url);	
	 
    })
    .catch((err) => {
		 setShowSpinner('none')
      console.error("Error:", err);
	alert(err)
    });
}





// rest api to delete the sample page that is automatically create when we create a new website

const deleteSamplePage=async(wp_url)=>{
	axios.delete("http://localhost/zuribuild/"+wp_url+"/wp-json/wp/v2/pages/2", {
 headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        }
})
.then(
res => {
	alert("Default page deleted")
})
.catch(err => {
	alert(err)
	console.log(err)
});
	
}


// rest API to generate images that will be use for the website via pexels API

const getNewImagesForWebsite=async()=>{

axios.get('https://api.pexels.com/v1/search', {
    headers: {
      Authorization: 'hlMsBY7tC1kHzAmGK2M4SwixocehvaIwi5oV0joaWe0HhQA5tS3UDzPq',
    },
    params: {
      query: businessType,
      per_page: 15,
    },
  })
  .then((response) => {
    // ✅ Success
    console.log("Photos fetched successfully!");
    const photos = response.data.photos;
	setRemoteImages(response.data.photos);
	console.log(photos)
   /* photos.forEach((photo, i) => {
      console.log(`${i + 1}. ${photo.src.medium}`);
    }); */
  })
  .catch((error) => {
    // ❌ Error
    if (error.response) {
      console.error("API responded with error:", error.response.status, error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error setting up request:", error.message);
    }
  });
}	
	
	
	
// rest API to save media library to the website to wordpress API
const saveImagesLibray=async()=>{


alert("save images libraries for the current website")
}
















// rest API TO CREATE AND STRUCTURE CONTENT with openAI API
const createWebsiteStructureViaAI=async(wp_url)=>{
//alert("the website json content had been create through openAI")
const OPENAI_API_KEY='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';
try {
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-5", // lightweight but strong
        messages: [
          {
            role: "system",
            content: "You are an AI that generates structured JSON for professional websites."
          },
          {
            role: "user",
            content: `
Generate a structured JSON for a professional website. 
It must have 4 pages: Home, About, Services, Contact. 
Each page should contain sections with title, paragraph, and images.
If services are provided, make sure to create a detailed Services page.
include navigation menu that will match the number of pages and each menu will 
have the name or title of the pages created.
if images are not provided use a default placeholder images instead from the link
https://placehold.co/widthxheight .

Business Info:
- Name: ${businessName}
- Description: ${businessType}
- Address: ${businessAddress || "Not provided"}
- Email: ${businessEmail || "Not provided"}
- Phone: ${businessPhone || "Not provided"}
- Services: ${JSON.stringify(services || [])}

Use these image URLs where relevant if available:
${images.join("\n")}
          `
          }
        ],
        
      },
      {
        headers: {  
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "Content-Type": "application/json"
        }
      }
    );

    const aiContent = response.data.choices[0].message.content;
	//alert(response.data.choices[0].message.content)
	//alert(urlPath);
	console.log(aiContent);
	//setOpenAIResult(JSON.parse(aiContent))
	var segmentizedAIContent=JSON.parse(aiContent)
	
	setTimeout(function() {
  createPagesForWebsite(wp_url,segmentizedAIContent);
}, 10000);
	
	
  //  return JSON.parse(aiContent); // structured JSON ready to send to WordPress API
  } catch (error) {
    console.error("Error generating site content:", error);
	//createWebsiteStructureViaAI();
    return null;
  }	
	
}







//function to generate pages for the website we just created 


const createPagesForWebsite=async(wp_url,content)=>{
	var createdPageNumber=0;
	var pagesCreated=[];
	
	
	for (let page of content.pages) {
      const content = convertJsonToWpBlocks(page);
  // alert(page.id);
   
     try{
   const response=  await axios.post(
        "http://localhost/"+wp_url+"/wp-json/wp/v2/pages",
        {
          title: page.id,
		 // title: "page"+createdPageNumber+1,
		//  slug: "page"+createdPageNumber+1,
          content: content,
          status: "publish"
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
	  console.log('Page created successfully:', response.data);
	   const pageId = response.data.id;
      const pageTitle = response.data.title.rendered;
      createdPageNumber+=1;
	  
	  
	//  pagesCreated.push([pageTitle,pageId])
   //   console.log(`✅ Page created: ${pageTitle} (ID: ${pageId})`);
	
	 }
	 
	 catch (error) {
		 alert(error)
            console.error('Error creating page:', error.response ? error.response.data : error.message);
            throw error;
			//createPagesForWebsite();
        }
	  
    }



	
}










// rest API to create pages for the website though the wordpress
const createPages=async()=>{
	
	alert("the pages for the website are being created")
}




	
	
	
	
	
	
	
	
	
	
	
	
	
  return (
  <>
  
  <style>{`

        body {

          margin: 0;

          font-family: Arial, sans-serif;

          background: linear-gradient(to bottom, rgba(128,0,128,0.8), rgba(0,0,0,0.8));
		  
		  background-attachment:fixed;
          height:100%;
          color: #000;

        }



        /* Header */

        .header {

          display: flex;

          justify-content: space-between;

          align-items: center;

          padding: 20px;

          background-color: white;
           display:none;
        }


   .logo { font-size: 26px; font-weight: 800; color: var(--secondary-red); letter-spacing: -1px; text-decoration: none;}



        .step {

          font-size: 14px;
          font-weight:550;
          color: #555;

        }



        /* Progress Bar */

        .progress-bar {

          width: 100vw;

          height: 4px;

          background-color: rgb(228,228,230);

        }
		
		
		
		#progress-indicator {

         // width: 20vw;

          height: 4px;

          background-color: black;
		  transition: width 0.6s ease; 

        }



        /* Body */

        .container {

          display: flex;
          flex-direction: column;
          justify-content: center;

          align-items: center;

          padding: 40px 20px;
		  

        }



        .content {

          width: 100%;

          max-width: 500px;

          background:white;
		  padding:10px;
		  border-radius:10px;
          box-shadow: 2px 2px 2px silver;
        }



        h2 {

          margin-bottom: 20px;

          font-size: 24px;

          color: #000;

        }



        .input-box {

          width: 100%;

          height: 50px;

          border-radius: 25px;

          border: 1px solid #ccc;

          padding: 0 15px;

          font-size: 16px;

          margin-bottom: 20px;

          box-sizing: border-box;

        }

  .gmail-registration-block{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  }
  
  

        .btn {

          width: 100%;

          height: 50px;

          border-radius: 25px;

          border: none;

          background-color: black;

          color: white;

          font-size: 16px;

          cursor: pointer;

          transition: 0.3s;

        }
		
		
		.gmail-ic{
		width:30px;
		height:30px;
		}
		
		
		
		.website-btn{
		width:33vw !important;
		background-color: navy
		}



/* Fade effect */
        .fade {
          opacity: 0;
          transform: translateY(10px);
          animation: fadeIn 0.6s ease forwards;
        }

        @keyframes fadeIn {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }



        .btn:hover {

          background-color: #5a0e8f;

        }



        /* Responsive */

        @media (min-width: 768px) {

          .content {

            width: 40%;

          }
		  
		  
		  

        }



        @media (max-width: 767px) {

          .content {

            width: 100%;

          }
		  
		  .website-btn{
		  width:100% !important;
		  }

        }

      `}</style>



      {/* Header */}

      <header className="header">

        <div className="logo">ZuriBuild</div>

        <div className="step">Step {step + 1} of {questions.length}</div>

      </header>



  



      {/* Body */}

      <div className="container">

        <div className="content">
		
		
		<div  style={{display:'none'}}>
<p>business name: {businessName} </p>
<p>business type: {businessType} </p>
<p>business address: {businessAddress} </p>
<p>business email: {businessEmail} </p>
<p>business phone: {businessPhone} </p>
<p>service: {JSON.stringify(services)} </p>
<p>images: {JSON.stringify(images)} </p> 
		</div>
		

  
 
     <div key={step} className="fade">
          <div className="logo">
		   <img src="/zuribuild.png"  
	   style={{
		   width:'40px'
	   }}/>
		  
		  ZuriBuild
		  
		  </div>
		  
		  <h2  style={{
					marginTop:'30px',
textAlign:'center',	

color:'black',
       
	
	  fontSize: '26px',
	  fontWeight: '800',
	  letterSpacing: '-1px',
	  textDecoration: 'none',			
		  }}>
		
		  {t("registration.registration")}
		  </h2>
     
	 
	
	<div  style={{
	marginTop:'20px'	
	}}>
	
	
	
	          <input type="text" className="input-box" 
		  placeholder={t("registration.placeholder_name")}
		  value={fullName}
 onChange={(e) => 
   setFullName(e.target.value)
 }		
		  />
	
	
	
	
	
	
          <input type="text" className="input-box" 
		  placeholder={t("registration.placeholder_email")}
		  value={email}
 onChange={(e) => 
   setEmail(e.target.value)
 }		
		  />
		  
		  
		  
		  
		  <span  style={{
			 color:'green',
			 fontSize:'12px',
			 display:'none' 
		  }}>
		  {t("registration.password_test")}
		</span>		  
        <input type="password" className="input-box" 
		  placeholder={t("registration.placeholder_password")}
		  value={password}
 onChange={(e) => 
   setPassword(e.target.value)
 }		
		  />		  
		  
		  

		  

	 </div> 
	  

	  

	  
	  
		  </div>
		  
      <div   style={{
		 color:'red',
         display:showInputReply,		 
	  }}>
	  {inputReply}
	  </div>
	 
       
		 
            <button className="btn" onClick={register2}>
			
			{t("registration.register")}
			<div class="spinner-grow spinner-grow-sm" role="status" 
			style={{
				marginLeft:'10px',
				display:showSpinner,
			}}>
 
</div>
			</button>
       
           
        <div  className="gmail-registration-block">
		<p  style={{
		margin:'30px',
		}}>
		{t("registration.or")}
		</p>
		
		
		<div>
		
		
		
		{/* <PhoneInput
      placeholder="Enter phone number"
      value={pn}
		onChange={setPn}/> */}
		
		
			 <button onClick={loginWithFacebook} type="button" class="btn btn-primary btn-lg website-btn">
	 <span class="bi-facebook"></span> {t("registration.register_with_facebook")} 
	 </button>
	 
	 
	 
	  <button type="button" onClick={loginWithGmail}     class="btn btn-primary btn-lg website-btn"  style={{background:'purple',marginTop:'10px'}}>
	 <img src="/images/gmail.png"  className="gmail-ic"/> {t("registration.register_with_gmail")} 
	 </button>
	 
	 
	 
	 <div>
	 <p  style={{
		   textAlign:'center',
		   marginTop:'15px',
	 }}>
   
	{t("registration.already_have_account")} 
   
   {''} {''}
	
	 <Link to="/login">
	 {t("registration.login")}  
	
	 </Link>
	 </p>
	 </div>
		</div>
		
		
		</div>

        </div>
		
		
		
   


      </div> 
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	


<div ref={modalRef} class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add a new service</h5>
        <button type="button" class="btn-close" onClick={closeModal} onC data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <input type="text" className="input-box" 
		  placeholder="Service name"
         
value={selectedServiceName}
 onChange={(e) => 
   setSelectedServiceName(e.target.value)
 }		 
		  />
		  <br/>
		  
		  <textarea placeholder="Service description here ...." className="input-box"   style={{
			  borderRadius:"10px",
			  height:"100px",
		  }}
		  
		  value={selectedServiceDescription}
 onChange={(e) => 
   setSelectedServiceDescription(e.target.value)
 }		 
		  
		  >
		  
		  </textarea>
      </div>
      <div class="modal-footer">
	   <button type="button" onClick={addNewService} class="btn btn-primary"  style={{background:'green'}}>Save changes</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"  onClick={closeModal}>Close</button>
       
      </div>
    </div>
  </div>
</div> 




	  
	 
<ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"

/>







 <div  style={{
		width:'100%',
        height:'120vh',
        background:'rgba(0,0,0,0.8)',
		position:'absolute',
		top:'1px',
		 display:showModalLoader ,
         alignItems:'center',
		 justifyContent:'center',
		
	  }}>
	  
	  
	  <div  style={{
		
	  }}>
	  <Mosaic color="purple" size="small" text="loading..." textColor="white" />
	  </div>
	  
	  </div>
	  
	  
	  </>
  );
}